export const USER_TYPE = {
    ESSENTIAL_USER: "Essential",
    EFILE_PLUS_USER: "eFile Plus",
    ENTERPRISE_USER: "Enterprise",
    MEMBER_USER: "Member",
}
export const USER_PLAN_NAME = {
    ESSENTIAL_USER: "ESSENTIAL_USER",
    EFILE_PLUS_USER: "EFILE_PLUS_USER",
    ENTERPRISE_USER: "ENTERPRISE_USER",
    MEMBER_USER: "MEMBER_USER"
}

export const USER_TYPE_MAPPING = {
    ESSENTIAL_USER: 1,
    EFILE_PLUS_USER: 1,
    ENTERPRISE_USER: 3,
    MEMBER_USER: [2,4],
}